<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 20:54:59
-->
<template>
  <veStuLiteraryAward viewType="shen" slot="table"></veStuLiteraryAward>
</template>

<script>
import veStuLiteraryAward from './base/veStuLiteraryAward';
export default {
  components: {
    veStuLiteraryAward
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
